// Module
var code = `<predicate predicates="\$ctrl.predicates"
           type="\$ctrl.type"
           access-input="\$ctrl.inputDefinition"
           ng-disabled="\$ctrl.ngDisabled">

  <select ng-options="ar.value as ar.label for ar in \$ctrl.inputDefinitions"
          ng-model="\$ctrl.inputDefinition"
          ng-change="\$ctrl.inputDefinitionChanged()"
          ng-disabled="\$ctrl.ngDisabled"
          required>
  </select>

  <multiselect items="\$ctrl.productDefinitionMap"
               ng-model="\$ctrl.value"
               label-property="'label'"
               value-property="'value'"
               select-all-option="true"
               ng-disabled="\$ctrl.ngDisabled"
               ng-required="true"
               ng-change="\$ctrl.valueChanged()">
  </multiselect>

</predicate>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/security/role-write-access/predicates/product-definition-predicate.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;